import React, { useEffect, useState } from 'react'
import { Button, Space, Table } from 'antd'
import { menuAdminRequest, errorMessage } from './api'
import HelpHint from './HelpHint'

// 2026-10-20 coder(lq): 只读审计视图，没有一键回滚，避免旧快照覆盖后续正式授权。
export default function HistoryPanel({ revision, onError }) {
    const [query, setQuery] = useState({ page: 1, size: 20 })
    const [data, setData] = useState({ items: [], total: 0 })
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        let active = true; setLoading(true)
        menuAdminRequest('history', { params: query }).then(result => { if (active) setData(result) })
            .catch(error => { if (active) onError(errorMessage(error)) }).finally(() => { if (active) setLoading(false) })
        return () => { active = false }
    }, [query, revision, onError])
    const columns = [
        { title: '序号', dataIndex: 'id' }, { title: '操作人ID', dataIndex: 'actor' },
        { title: '操作', dataIndex: 'action' }, { title: '原因', dataIndex: 'reason' }, { title: '时间', dataIndex: 'createdAt' },
    ]
    return <section><Space className="menu-api-toolbar">
        <Button onClick={() => setQuery({ ...query })}>刷新记录</Button>
        <HelpHint label="手工变更记录说明">此处记录页面手工变更及前后快照；历史机器增量导入不包含在本表中。</HelpHint>
        </Space>
        <Table rowKey="id" dataSource={data.items} columns={columns} loading={loading} scroll={{ x: 700 }}
            expandable={{ expandedRowRender: row => <div className="menu-api-compare">
                <section><strong>修改前</strong><pre>{row.beforeJson || '无'}</pre></section>
                <section><strong>修改后</strong><pre>{row.afterJson || '无'}</pre></section></div> }}
            pagination={{ current: query.page, pageSize: query.size, total: data.total, onChange: page => setQuery({ ...query, page }) }}
            locale={{ emptyText: '暂无手工变更记录' }} /></section>
}
